function changeVariantMetafield() {
    const strapLengthFieldsets = document.querySelectorAll('[data-option-slug="strap-length"]');
    strapLengthFieldsets.forEach((fieldset) => {
        const variantSelectBlock = fieldset.closest('variant-selects');
        const fieldsetInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));

        if (fieldsetInputs.length == 0) return;

        function updateInputs(selectedVariantValue) {
            variantSelectBlock.querySelectorAll(`[data-variant-string]`).forEach((variantSpan) => {
                if (variantSpan.dataset.variantString != selectedVariantValue) {
                    variantSpan.style.display = 'none';
                } else {
                    variantSpan.style.display = 'inline-block';
                }
            });
        }

        const selectedVariantValue = fieldsetInputs.find((input) => input.checked)?.value || '';
        updateInputs(selectedVariantValue);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    changeVariantMetafield();

    const productInfos = document.querySelectorAll('product-info');
    productInfos.forEach((productInfo) => {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    changeVariantMetafield();
                    break;
                }
            }
        });
        observer.observe(productInfo, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value', 'checked']
        });

        productInfo.addEventListener('change', (e) => {
            if (e.target.tagName === 'INPUT') {
                changeVariantMetafield();
            }
        });
    });
});